import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * 多标签页
 * */
import { get, cloneDeep } from 'lodash';
import router from '@/router';
import Setting from '@/setting';
import { getAllSiderMenu, getNativeMenuSider, includeArray } from '@/libs/system';
import store from "@/store";

// 判定是否需要缓存
var isKeepAlive = function isKeepAlive(data) {
  return get(data, 'meta.cache', false);
};
export default {
  namespaced: true,
  state: {
    // 可以在多页 tab 模式下显示的页面
    pool: [],
    // 当前显示的多页面列表
    opened: Setting.page.opened,
    lasted: [],
    // 当前页面
    current: '',
    // 需要缓存的页面 name
    keepAlive: []
  },
  actions: {
    /**
     * @description 从持久化数据载入分页列表
     */
    openedLoad: function openedLoad(_ref, _ref2) {
      var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState;
      var _ref2$loadOpenedTabs = _ref2.loadOpenedTabs,
        loadOpenedTabs = _ref2$loadOpenedTabs === void 0 ? true : _ref2$loadOpenedTabs,
        _ref2$initOpened = _ref2.initOpened,
        initOpened = _ref2$initOpened === void 0 ? [] : _ref2$initOpened;
      return new Promise(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
          var value, valid;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(initOpened && initOpened.length)) {
                  _context.n = 1;
                  break;
                }
                _context.n = 1;
                return commit('init', initOpened);
              case 1:
                _context.n = 2;
                return dispatch('admin/db/get', {
                  dbName: 'sys',
                  path: 'page.opened',
                  defaultValue: Setting.page.opened,
                  user: true
                }, {
                  root: true
                });
              case 2:
                value = _context.v;
                if (!loadOpenedTabs) value = [];
                // 在处理函数中进行数据优化 过滤掉现在已经失效的页签或者已经改变了信息的页签
                // 以 fullPath 字段为准
                // 如果页面过多的话可能需要优化算法
                // valid 有效列表 1, 1, 0, 1 => 有效, 有效, 失效, 有效
                valid = []; // 处理数据
                state.opened = value.map(function (opened) {
                  // 忽略首页
                  if (opened.fullPath === '/index') {
                    valid.push(1);
                    return opened;
                  }
                  // 尝试在所有的支持多标签页的页面里找到 name 匹配的页面
                  var find = state.pool.find(function (item) {
                    return item.name === opened.name;
                  });
                  // 如果 value 项有 keepMeta 字段，则保留 meta
                  if (opened.keepMeta) {
                    find.meta = Object.assign({}, opened.meta);
                  }
                  // 记录有效或无效信息
                  valid.push(find ? 1 : 0);
                  // 返回合并后的数据 新的覆盖旧的
                  // 新的数据中一般不会携带 params 和 query, 所以旧的参数会留存
                  return Object.assign({}, opened, find);
                });
                // @TODO 注释这里是因为，有一些没有在侧边栏展示的页面，在tab栏，比如新增、编辑，当刷新页面时，这些页面会被关闭，所以注释掉
                // .filter((opened, index) => valid[index] === 1)
                // // 对 menu 鉴权过滤
                // .filter(opened => {
                //     const allSiderMenu = getAllSiderMenu(getNativeMenuSider());
                //     console.log(allSiderMenu)
                //     const find = allSiderMenu.find(item => item.path === opened.fullPath);
                //     let state = true;
                //     // console.log(opened,find)
                //     if (find) {
                //         if (find.auth) {
                //             const userInfo = rootState.admin.user.info;
                //             // @权限
                //             const access = cloneDeep(userInfo.access) || [];
                //             // 给 access 强制加一个 hidden 的权限，否则菜单隐藏后，Tabs 页签会不显示该页签
                //             access.push('hidden');
                //             // 如果用户当前的权限，不是该 menu 对应的 权限，则过滤这个 Tab
                //             if (access && !includeArray(find.auth, access)) state = false;
                //         }
                //     } else {
                //         state = false
                //     }
                //     return state;
                // });
                // 根据 opened 数据生成缓存设置
                commit('keepAliveRefresh');
                // end
                resolve();
              case 3:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    /**
     * 将 opened 属性赋值并持久化 在这之前请先确保已经更新了 state.opened
     */
    opened2db: function opened2db(_ref4) {
      var state = _ref4.state,
        dispatch = _ref4.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                // 设置数据
                dispatch('admin/db/set', {
                  dbName: 'sys',
                  path: 'page.opened',
                  value: state.opened,
                  user: true
                }, {
                  root: true
                });
                // end
                resolve();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    lastOpen2db: function lastOpen2db(_ref6) {
      var state = _ref6.state,
        dispatch = _ref6.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resolve) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                // 设置数据
                dispatch('admin/db/set', {
                  dbName: 'sys',
                  path: 'page.lasted',
                  value: state.lasted,
                  user: true
                }, {
                  root: true
                });
                // end
                resolve();
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref7.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 更新页面列表上的某一项
     * @param {Object} param { index, params, query, fullPath } 路由信息
     */
    openedUpdate: function openedUpdate(_ref8, _ref9) {
      var state = _ref8.state,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;
      var index = _ref9.index,
        params = _ref9.params,
        query = _ref9.query,
        fullPath = _ref9.fullPath,
        meta = _ref9.meta,
        _ref9$keepMeta = _ref9.keepMeta,
        keepMeta = _ref9$keepMeta === void 0 ? false : _ref9$keepMeta,
        pageName = _ref9.pageName;
      return new Promise(/*#__PURE__*/function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(resolve) {
          var page;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                // 更新页面列表某一项
                page = state.opened[index];
                page.index = index;
                page.params = params || page.params;
                page.query = query || page.query;
                page.fullPath = fullPath || page.fullPath;
                page.meta = meta || page.meta;
                page.keepMeta = keepMeta;
                page.pageName = pageName || page.pageName;
                state.opened.splice(index, 1, page);
                // 持久化
                _context4.n = 1;
                return dispatch('opened2db');
              case 1:
                // end
                resolve();
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref0.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 更新页面当前项
     * @param {Object} param { params, query, fullPath } 路由信息
     */
    currentUpdate: function currentUpdate(_ref1, _ref10) {
      var state = _ref1.state,
        commit = _ref1.commit,
        dispatch = _ref1.dispatch;
      var params = _ref10.params,
        query = _ref10.query,
        fullPath = _ref10.fullPath,
        meta = _ref10.meta,
        _ref10$keepMeta = _ref10.keepMeta,
        keepMeta = _ref10$keepMeta === void 0 ? false : _ref10$keepMeta;
      return new Promise(/*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(resolve) {
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                  var index, page;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        // 更新当前项
                        index = state.opened.findIndex(function (item) {
                          return item.fullPath === state.current;
                        });
                        page = state.opened[index];
                        page.params = params || page.params;
                        page.query = query || page.query;
                        page.fullPath = fullPath || page.fullPath;
                        page.meta = meta || page.meta;
                        page.keepMeta = keepMeta;
                        state.opened.splice(index, 1, page);
                        // 持久化
                        _context5.n = 1;
                        return dispatch('opened2db');
                      case 1:
                        // end
                        resolve();
                      case 2:
                        return _context5.a(2);
                    }
                  }, _callee5);
                })), 0);
              case 1:
                return _context6.a(2);
            }
          }, _callee6);
        }));
        return function (_x5) {
          return _ref11.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 新增一个 tag (打开一个页面)
     * @param {Object} param new tag info
     */
    add: function add(_ref13, _ref14) {
      var state = _ref13.state,
        commit = _ref13.commit,
        dispatch = _ref13.dispatch;
      var tag = _ref14.tag,
        params = _ref14.params,
        query = _ref14.query,
        fullPath = _ref14.fullPath;
      return new Promise(/*#__PURE__*/function () {
        var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(resolve) {
          var newTag;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                if (!['403', '404', '500'].includes(tag.name)) {
                  _context7.n = 1;
                  break;
                }
                resolve();
                return _context7.a(2);
              case 1:
                newTag = tag;
                newTag.params = params || newTag.params;
                newTag.query = query || newTag.query;
                newTag.fullPath = fullPath || newTag.fullPath;
                // 添加进当前显示的页面数组
                state.opened.push(newTag);
                // 如果这个页面需要缓存 将其添加到缓存设置
                if (isKeepAlive(newTag)) {
                  commit('keepAlivePush', tag.name);
                }
                // 持久化
                _context7.n = 2;
                return dispatch('opened2db');
              case 2:
                // end
                resolve();
              case 3:
                return _context7.a(2);
            }
          }, _callee7);
        }));
        return function (_x6) {
          return _ref15.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 打开一个新的页面
     * @param {Object} param 从路由钩子的 to 对象上获取 { name, params, query, fullPath } 路由信息
     */
    open: function open(_ref16, _ref17) {
      var state = _ref16.state,
        commit = _ref16.commit,
        dispatch = _ref16.dispatch;
      var name = _ref17.name,
        params = _ref17.params,
        query = _ref17.query,
        fullPath = _ref17.fullPath,
        pageName = _ref17.pageName;
      return new Promise(/*#__PURE__*/function () {
        var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(resolve) {
          var opened, pageOpenedIndex, pageOpened, access, pool, lasted, route, lastedMap, existRoute, page;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                // 已经打开的页面
                // debugger
                opened = state.opened; // 判断此页面是否已经打开 并且记录位置
                pageOpenedIndex = 0;
                pageOpened = opened.find(function (page, index) {
                  // const same = page.fullPath === fullPath;
                  var same = page.name === name;
                  pageOpenedIndex = same ? index : pageOpenedIndex;
                  return same;
                });
                if (!store.state.admin.user.info) {
                  _context8.n = 3;
                  break;
                }
                access = store.state.admin.user.info.access || [];
                pool = state.pool.filter(function (item) {
                  if (item.meta.hidden || item.meta.hideSider) {
                    return false;
                  }
                  var auth = item.meta.auth;
                  if (!auth) {
                    return true;
                  }
                  return includeArray(auth, access) || access.includes("admin");
                });
                _context8.n = 1;
                return dispatch('admin/db/get', {
                  dbName: 'sys',
                  path: 'page.lasted',
                  defaultValue: pool.slice(0, 8),
                  user: true
                }, {
                  root: true
                });
              case 1:
                lasted = _context8.v;
                route = pool.find(function (item) {
                  return item.name === name;
                });
                if (!route) {
                  _context8.n = 2;
                  break;
                }
                lastedMap = new Map();
                lasted.forEach(function (item) {
                  lastedMap.set(item.name, item);
                });
                existRoute = lastedMap.get(name);
                if (existRoute) {
                  lastedMap.delete(name);
                }
                lasted = _toConsumableArray(lastedMap.values());
                lasted.splice(0, 0, _objectSpread(_objectSpread({}, route), {}, {
                  params: params,
                  query: query
                }));
                lasted = lasted.slice(0, 8);
                state.lasted = lasted;
                _context8.n = 2;
                return dispatch('lastOpen2db');
              case 2:
                state.lasted = lasted;
              case 3:
                if (!pageOpened) {
                  _context8.n = 5;
                  break;
                }
                _context8.n = 4;
                return dispatch('openedUpdate', {
                  index: pageOpenedIndex,
                  params: params,
                  query: query,
                  fullPath: fullPath,
                  pageName: pageName
                });
              case 4:
                _context8.n = 6;
                break;
              case 5:
                // 页面以前没有打开过
                page = state.pool.find(function (t) {
                  return t.name === name;
                }); // 如果这里没有找到 page 代表这个路由虽然在框架内 但是不参与标签页显示
                if (!page) {
                  _context8.n = 6;
                  break;
                }
                page.pageName = pageName;
                _context8.n = 6;
                return dispatch('add', {
                  tag: Object.assign({}, page),
                  params: params,
                  query: query,
                  fullPath: fullPath
                });
              case 6:
                commit('currentSet', fullPath);
                // end
                resolve();
              case 7:
                return _context8.a(2);
            }
          }, _callee8);
        }));
        return function (_x7) {
          return _ref18.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭一个 tag (关闭一个页面)
     * @param {Object} param { tagName: 要关闭的标签名字 }
     */
    close: function close(_ref19, _ref20) {
      var state = _ref19.state,
        commit = _ref19.commit,
        dispatch = _ref19.dispatch;
      var _ref20$tagName = _ref20.tagName,
        tagName = _ref20$tagName === void 0 ? state.current : _ref20$tagName;
      return new Promise(/*#__PURE__*/function () {
        var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(resolve) {
          var newPage, isCurrent, len, i, index, _newPage, _newPage$name, name, _newPage$params, params, _newPage$query, query, routerObj;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                // 下个新的页面
                state.opened = state.opened.filter(function (item) {
                  return !Setting.unOpenMenuNames.includes(item.name);
                });
                newPage = state.opened[0];
                isCurrent = state.current === tagName; // 如果关闭的页面就是当前显示的页面
                if (!isCurrent) {
                  _context9.n = 3;
                  break;
                }
                // 去找一个新的页面
                len = state.opened.length;
                i = 0;
              case 1:
                if (!(i < len)) {
                  _context9.n = 3;
                  break;
                }
                if (!(state.opened[i].fullPath === tagName)) {
                  _context9.n = 2;
                  break;
                }
                // 是否只剩最后一个，是则跳首页
                if (len > 1) {
                  // 如果是最后一个，则向前一个跳，否则向下一个跳
                  if (i === len - 1) {
                    newPage = state.opened[i - 1];
                  } else {
                    newPage = state.opened[i + 1];
                  }
                } else {
                  newPage = {};
                }
                return _context9.a(3, 3);
              case 2:
                i++;
                _context9.n = 1;
                break;
              case 3:
                // 找到这个页面在已经打开的数据里是第几个
                index = state.opened.findIndex(function (page) {
                  return page.fullPath === tagName;
                });
                if (index >= 0) {
                  // 如果这个页面是缓存的页面 将其在缓存设置中删除
                  commit('keepAliveRemove', state.opened[index].name);
                  // 更新数据 删除关闭的页面
                  state.opened.splice(index, 1);
                }
                // 持久化
                _context9.n = 4;
                return dispatch('opened2db');
              case 4:
                // 最后需要判断是否需要跳到首页
                if (isCurrent) {
                  _newPage = newPage, _newPage$name = _newPage.name, name = _newPage$name === void 0 ? 'index' : _newPage$name, _newPage$params = _newPage.params, params = _newPage$params === void 0 ? {} : _newPage$params, _newPage$query = _newPage.query, query = _newPage$query === void 0 ? {} : _newPage$query;
                  routerObj = {
                    name: name,
                    params: params,
                    query: query
                  };
                  router.push(routerObj, function () {});
                }
                // end
                resolve();
              case 5:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function (_x8) {
          return _ref21.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前标签左边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeLeft: function closeLeft(_ref22) {
      var state = _ref22.state,
        commit = _ref22.commit,
        dispatch = _ref22.dispatch;
      var _ref23 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref23.pageSelect;
      return new Promise(/*#__PURE__*/function () {
        var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(resolve) {
          var pageAim, currentIndex;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                if (currentIndex > 0) {
                  // 删除打开的页面 并在缓存设置中删除
                  state.opened.splice(1, currentIndex - 1).forEach(function (_ref25) {
                    var name = _ref25.name;
                    return commit('keepAliveRemove', name);
                  });
                }
                state.current = pageAim;
                if (router.currentRoute.value.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context0.n = 1;
                return dispatch('opened2db');
              case 1:
                // end
                resolve();
              case 2:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x9) {
          return _ref24.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前标签右边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeRight: function closeRight(_ref26) {
      var state = _ref26.state,
        commit = _ref26.commit,
        dispatch = _ref26.dispatch;
      var _ref27 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref27.pageSelect;
      return new Promise(/*#__PURE__*/function () {
        var _ref28 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(resolve) {
          var pageAim, currentIndex;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                // 删除打开的页面 并在缓存设置中删除
                state.opened.splice(currentIndex + 1).forEach(function (_ref29) {
                  var name = _ref29.name;
                  return commit('keepAliveRemove', name);
                });
                // 设置当前的页面
                state.current = pageAim;
                if (router.currentRoute.value.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context1.n = 1;
                return dispatch('opened2db');
              case 1:
                // end
                resolve();
              case 2:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function (_x0) {
          return _ref28.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前激活之外的 tag
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeOther: function closeOther(_ref30) {
      var state = _ref30.state,
        commit = _ref30.commit,
        dispatch = _ref30.dispatch;
      var _ref31 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref31.pageSelect;
      return new Promise(/*#__PURE__*/function () {
        var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(resolve) {
          var pageAim, currentIndex;
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                // 删除打开的页面数据 并更新缓存设置
                if (currentIndex === 0) {
                  state.opened.splice(1).forEach(function (_ref33) {
                    var name = _ref33.name;
                    return commit('keepAliveRemove', name);
                  });
                } else {
                  state.opened.splice(currentIndex + 1).forEach(function (_ref34) {
                    var name = _ref34.name;
                    return commit('keepAliveRemove', name);
                  });
                  state.opened.splice(1, currentIndex - 1).forEach(function (_ref35) {
                    var name = _ref35.name;
                    return commit('keepAliveRemove', name);
                  });
                }
                // 设置新的页面
                state.current = pageAim;
                if (router.currentRoute.value.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context10.n = 1;
                return dispatch('opened2db');
              case 1:
                // end
                resolve();
              case 2:
                return _context10.a(2);
            }
          }, _callee10);
        }));
        return function (_x1) {
          return _ref32.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭所有 tag
     * @param {Object} state vuex state
     */
    closeAll: function closeAll(_ref36) {
      var state = _ref36.state,
        commit = _ref36.commit,
        dispatch = _ref36.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref37 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(resolve) {
          return _regenerator().w(function (_context11) {
            while (1) switch (_context11.n) {
              case 0:
                // 删除打开的页面 并在缓存设置中删除
                state.opened.splice(1).forEach(function (_ref38) {
                  var name = _ref38.name;
                  return commit('keepAliveRemove', name);
                });
                // 持久化
                _context11.n = 1;
                return dispatch('opened2db');
              case 1:
                // 关闭所有的标签页后需要判断一次现在是不是在首页
                if (router.currentRoute.value.name !== 'index') {
                  router.push({
                    name: 'index'
                  }, function () {});
                }
                // end
                resolve();
              case 2:
                return _context11.a(2);
            }
          }, _callee11);
        }));
        return function (_x10) {
          return _ref37.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 直接更新 opened，用于拖拽调整页签顺序
     * */
    updateOpened: function updateOpened(_ref39, _ref40) {
      var state = _ref39.state,
        commit = _ref39.commit,
        dispatch = _ref39.dispatch;
      var opened = _ref40.opened;
      return new Promise(/*#__PURE__*/function () {
        var _ref41 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(resolve) {
          return _regenerator().w(function (_context12) {
            while (1) switch (_context12.n) {
              case 0:
                state.opened = opened;
                // 持久化
                _context12.n = 1;
                return dispatch('opened2db');
              case 1:
                // end
                resolve();
              case 2:
                return _context12.a(2);
            }
          }, _callee12);
        }));
        return function (_x11) {
          return _ref41.apply(this, arguments);
        };
      }());
    }
  },
  mutations: {
    /**
     * @class keepAlive
     * @description 从已经打开的页面记录中更新需要缓存的页面记录
     * @param {Object} state vuex state
     */
    keepAliveRefresh: function keepAliveRefresh(state) {
      state.keepAlive = state.opened.filter(function (item) {
        return isKeepAlive(item);
      }).map(function (e) {
        return e.name;
      });
    },
    /**
     * @description 删除一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAliveRemove: function keepAliveRemove(state, name) {
      var list = _toConsumableArray(state.keepAlive);
      var index = list.findIndex(function (item) {
        return item === name;
      });
      if (index !== -1) {
        list.splice(index, 1);
        state.keepAlive = list;
      }
    },
    /**
     * @description 增加一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAlivePush: function keepAlivePush(state, name) {
      var keep = _toConsumableArray(state.keepAlive);
      keep.push(name);
      state.keepAlive = keep;
    },
    /**
     * @description 清空页面缓存设置
     * @param {Object} state vuex state
     */
    keepAliveClean: function keepAliveClean(state) {
      state.keepAlive = [];
    },
    /**
     * @class current
     * @description 设置当前激活的页面 fullPath
     * @param {Object} state vuex state
     * @param {String} fullPath new fullPath
     */
    currentSet: function currentSet(state, fullPath) {
      state.current = fullPath;
    },
    /**
     * @class pool
     * @description 保存 pool (候选池)
     * @param {Object} state vuex state
     * @param {Array} routes routes
     */
    init: function init(state, routes) {
      var pool = [];
      var _push = function push(routes) {
        routes.forEach(function (route) {
          if (route.children) {
            _push(route.children);
          } else {
            if (!route.hidden) {
              var meta = route.meta,
                name = route.name,
                path = route.path;
              pool.push({
                meta: meta,
                name: name,
                path: path
              });
            }
          }
        });
      };
      _push(routes);
      state.pool = pool;
    }
  }
};